export const colors = {
	badge: {
		primary: "bg-primary",
		secondary: "bg-secondary",
	},
	gradient: {
		"primary-to-secondary": "bg-gradient-to-r from-primary to-secondary",
		"secondary-to-primary": "bg-gradient-to-r from-secondary to-primary",
		"primary-to-primary": "bg-primary",
		"secondary-to-secondary": "bg-secondary",
	},
};
